// comparison-table.js

class ComparisonTable {
  constructor(el) {
    this.el = el;
    this.scrollEl = el.querySelector('.comparison-table__scroll');
    this.toggleBtns = el.querySelectorAll('.ct-toggle');
    this.table = el.querySelector('.ct-table');

    const style = getComputedStyle(el);
    this.labelColWidth = parseFloat(style.getPropertyValue('--ct-label-col-width')) || 194;
    this.minProductColWidth = parseFloat(style.getPropertyValue('--ct-product-col-width')) || 172;

    this.initDragScroll();
    this.initToggles();
  }

  // ─── Drag to scroll ──────────────────────────────────────────────
  initDragScroll() {
    const el = this.scrollEl;
    if (!el) return;

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let hasMoved = false;

    const onMouseDown = (e) => {
      if (e.button !== 0) return;
      isDown = true;
      hasMoved = false;
      startX = e.pageX - el.getBoundingClientRect().left;
      scrollLeft = el.scrollLeft;
    };

    const onMouseMove = (e) => {
      if (!isDown) return;
      const x = e.pageX - el.getBoundingClientRect().left;
      const delta = x - startX;
      if (Math.abs(delta) > 3) {
        hasMoved = true;
        el.classList.add('is-dragging');
        e.preventDefault();
        el.scrollLeft = scrollLeft - delta;
      }
    };

    const onMouseUp = () => {
      isDown = false;
      el.classList.remove('is-dragging');
    };

    el.addEventListener('mousedown', onMouseDown);
    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);

    // Prevent clicks on links while dragging
    el.addEventListener('click', (e) => {
      if (hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  // ─── Toggle columns ──────────────────────────────────────────────
  initToggles() {
    this.toggleBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const col = btn.dataset.col;
        const wasActive = btn.classList.contains('ct-toggle--active');

        // Prevent hiding all columns
        const activeBtns = [...this.toggleBtns].filter(b => b.classList.contains('ct-toggle--active'));
        if (wasActive && activeBtns.length <= 1) return;

        const isActive = btn.classList.toggle('ct-toggle--active');
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');

        this.el.querySelectorAll(`[data-col="${col}"]:not(.ct-toggle)`).forEach((cell) => {
          cell.classList.toggle('ct-col-hidden', !isActive);
        });

        this.updateColumnWidths();
      });
    });

    window.addEventListener('resize', () => this.updateColumnWidths());
    requestAnimationFrame(() => this.updateColumnWidths());
  }

  // ─── Recalculate column widths (table-layout: fixed) ─────────────
  updateColumnWidths() {
    if (!this.scrollEl) return;

    const activeCols = [...this.toggleBtns]
      .filter(b => b.classList.contains('ct-toggle--active'))
      .map(b => b.dataset.col);

    if (!activeCols.length) return;

    const containerWidth = this.scrollEl.clientWidth;
    if (!containerWidth) return;

    const available = containerWidth - this.labelColWidth;
    const colWidth = Math.max(Math.floor(available / activeCols.length), this.minProductColWidth);

    this.el.style.setProperty('--ct-product-col-width', colWidth + 'px');
  }

}

// Init all comparison tables on the page
function initComparisonTables() {
  document.querySelectorAll('.comparison-table').forEach((el) => {
    if (!el.dataset.ctInit) {
      el.dataset.ctInit = '1';
      new ComparisonTable(el);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initComparisonTables);
} else {
  initComparisonTables();
}

// Shopify section editor re-init
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target;
  if (section.querySelector('.comparison-table')) {
    section.querySelectorAll('.comparison-table').forEach((el) => {
      delete el.dataset.ctInit;
    });
    initComparisonTables();
  }
});
